// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__vnW7d"};